import { Pencil2Icon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { Allowance } from "./schema";

import { useViewModal } from "../view-allowance-modal/use-view-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Allowance;

  const { onOpenChange: onViewOpen, setAllowanceRequest } = useViewModal();

  return (
    <Button
      size="icon"
      className="w-6 h-6"
      onClick={() => {
        setAllowanceRequest(originData);
        onViewOpen(true);
      }}
    >
      <Pencil2Icon />
    </Button>
  );
}
